import { render, staticRenderFns } from "./TableInfo.vue?vue&type=template&id=052344b2&"
import script from "./TableInfo.vue?vue&type=script&lang=js&"
export * from "./TableInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports